import { Component, Input, OnInit, AfterViewInit, ElementRef, ViewChild } from "@angular/core";

@Component({
    selector: "marquee-document",
    templateUrl: "./marquee-document.template.html",
    styleUrls: ["./marquee-document.style.scss"]
})

export class MarqueeDocument implements OnInit {
    @Input() item: any;

    constructor(
        private el: ElementRef
    ) { }

    ngOnInit() {
    }

    ngAfterViewInit() {
        if (this.el && this.el.nativeElement && this.el.nativeElement.classList) {
            this.el.nativeElement.classList.add('ready');
        }
    }
}    


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/marquee-document/marquee-document.component.ts